import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import { ConversationsListPage } from "../pages/ConversationsListPage";
import { HelpWidgetLayout } from "./common/HelpWidgetLayout";

interface ConversationLayoutProps {
  children: React.ReactNode;
}

export const ConversationLayout = ({ children }: ConversationLayoutProps) => {
  const { isExpanded, isSidebarOpen } = useHelpWidgetContext();

  return (
    <div className="scrollbar-hide flex h-full flex-col overflow-y-auto">
      <div className="flex size-full justify-end">
        {isExpanded && (
          <div
            className={classNames(
              "border-primary overflow-hidden border-r transition-opacity duration-200",
              {
                "flex-none w-[312px]": isSidebarOpen,
                "pointer-events-none w-0 opacity-0": !isSidebarOpen,
              },
            )}
          >
            <div className="h-full w-[312px] overflow-y-auto">
              <ConversationsListPage />
            </div>
          </div>
        )}
        <HelpWidgetLayout className="flex-none">
          <div className="scrollbar-hide flex h-full flex-col items-end overflow-y-auto">
            {children}
          </div>
        </HelpWidgetLayout>
      </div>
    </div>
  );
};
